export default "__VITE_ASSET__5IfItsGU__"